/**
 * @module mapbs.components.kleinbautenausschnitt.kleinbautenausschnitt
 */

import angular from 'angular';

import olInteractionDraw from 'ol/interaction/Draw.js';
import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';

import mapbsBsprintingService from 'mapbs/components/bsprinting/bsprintingservice.js';
import mapbsWfsService from 'mapbs/components/wfsservice/wfsservice.js';

const moduleKleinbautenausschnitt = angular.module('mapbsKleinbautenAusschnittModule', [
    mapbsBsprintingService.name,
    mapbsWfsService.name,
]);

moduleKleinbautenausschnitt.run(
    /* ngInject */ ($templateCache) => {
        $templateCache.put(
            'mapbs/kleinbautenausschnitt',
            require('./kleinbautenausschnitt.html')
        );
    }
);

/**
 * @type {!angular.Component}
 */
const kleinbautenausschnittComponent = {
    controller: 'mapbsKleinbautenAusschnittController as ctrl',
    templateUrl: 'mapbs/kleinbautenausschnitt',
    bindings: {
        'map': '<mapbsKleinbautenausschnittMap',
        'reportPanelActive': '<mapbsKleinbautenausschnittActive',
    },
};

moduleKleinbautenausschnitt.component('mapbsKleinbautenausschnitt', kleinbautenausschnittComponent);

class KleinbautenAusschnittController {
    /**
   * @constructor
   * @param {angular.Scope} $scope
   * @param {angular.$injector} $injector
   * @param {angular.$http} $http
   * @param {angular.$q} $q
   * @param {import('ngeo/misc/ToolActivate.js').default} ngeoToolActivateMgr
   * @param {mapbsWfsService} mapbsWfsService
   * @param {mapbsBsprintingService} mapbsBsprintingService
   * @private
   * @ngInject
   */
    constructor(
        $scope,
        $injector,
        $http,
        $q,
        ngeoToolActivateMgr,
        mapbsWfsService,
        mapbsBsprintingService
    ) {
    /** @type {angular.Scope} @private */
        this.scope = $scope;
        /** @type {angular.$http} @private */
        this.http = $http;
        /** @type {angular.$q} @private */
        this.q = $q;
        /** @type {mapbsWfsService} @private */
        this.wfsservice = mapbsWfsService;
        /** @type {mapbsBsprintingService} @private */
        this.printservice = mapbsBsprintingService;
        /** @type {string} @private */
        this.baseUrl = $injector.get('baseUrl');

        /** @type {boolean} @private */
        this.reportPanelActive;

        /** @type {string} */
        this.state = 'ready';

        /** @type {string?} */
        this.downloadurl = null;

        /**@type {?string} */
        this.warning;

        /** @type {boolean} @private */
        this.mapInteractionActive = false;
        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'mapInteractionActive'),
            false
        );

        /** @type {olInteractionDraw} @private */
        this.drawInteraction = new olInteractionDraw({
            type: /** @type {import("ol/geom/GeometryType.js").default} */ (
                'Polygon'
            ),
        });
        this.drawInteraction.on(
            'drawend',
            this.handleDrawInteractionEnd.bind(this)
        );

        this.scope.$watch(
            () => {
                return this.reportPanelActive;
            },
            (newVal) => {
                if (!newVal) {
                    this.setState('ready');
                }
            }
        );
    }

    /**
   * @param {string} state
   * @private
   */
    setState(state) {
        this.mapInteractionActive = false;
        this.map.removeInteraction(this.drawInteraction);

        switch (state) {
            case 'ready':
                break;
            case 'active':
                this.mapInteractionActive = true;
                this.map.addInteraction(this.drawInteraction);
                break;
            case 'dwnready':
            case 'waiting':
            default:
                this.warning = null;
                break;
        }
        this.state = state;
    }

    toggleState() {
        if (this.state === 'ready') {
            this.setState('active');
        } else {
            this.setState('ready');
        }
    }

    /**
   * @param {JQueryEventObject} event
   * @private
   */
    handleDrawInteractionEnd(event) {
        this.setState('waiting');
        const geom = event.feature.getGeometry();
        this.wfsservice
      .getFeatureByPolygon(geom, [
          'BS_Liegenschaften_Grundstuecke_Liegenschaftsparzelle',
      ])
      .then((resp) => {
          // check wheter liegenschaft / egrid has KB to prevent empty pages in report
          const egrids = [];
          resp.forEach((element) => egrids.push(element.get('bs_egrid')));
          this.http
          .get(`${this.baseUrl}filter_kb_egrids/${egrids.join(',')}`)
          .then(
              (resp) => {
                  console.log(resp);

                  if (resp.data.length === 0) {
                      //this.setState('active');
                      this.warning = 'Keine Parzellen mit Kleinbauten selektiert';
                  } else {
                      // create print -> go on with printing
                      this.printservice
                  .createMultiReport(
                      'kleinbautenriehen_report',
                      resp.data.join(',')
                  )
                  .then(
                      (dwnurl) => {
                          this.downloadurl = dwnurl;
                          this.setState('dwnready');
                      },
                      (error) => {
                          this.warning = error;
                      }
                  );
                  }
              },
              (error) => {
                  this.warning = 'Ein Fehler ist aufgetreten';
                  console.log(error);
              }
          );
      });
    }
}

moduleKleinbautenausschnitt.controller(
    'mapbsKleinbautenAusschnittController',
    KleinbautenAusschnittController
);

export default moduleKleinbautenausschnitt;
